module.exports = __webpack_public_path__ + "static/media/requests.7e93eae9.svg";